import { mobiClient } from '@/services/axiosConfig'
import { WIFICardReq, WIFICARDRes } from './types'

export const getWifiCardList = async (req: WIFICardReq): Promise<WIFICARDRes | undefined> => {
  try {
    const headers = {
      isdn: req.isdn
    }
    const res = await mobiClient.get('/wificard', { headers })
    return res.data
  } catch (e) {
    console.error('fetch data list failed', e)
  }
}
